import React, {Component} from 'react';
import './LoggedOut.css';
import {connect} from 'react-redux';
import handleError from '../handleError';
import Button from '../widgets/Button';
import {push} from "react-router-redux";

/**
 * Logged out page.
 */
class LoggedOut extends Component {
	onLogin = () => {
		const { login, redirectAuth, handleError } = this.props;
		login()
				.then(() => redirectAuth())
				.catch(handleError)
	};

	render() {
		return (
			<div className="LoggedOut">
				<div>
					<p>You have been logged out of the Syllabus Warehouse</p>
					<Button onClick={this.onLogin}>Log back in</Button>
				</div>
			</div>
		);
	}
}


const ConnectedLoggedOut = connect(
	() => ({}),
	dispatch => ({
		handleError: handleError(dispatch, true),
		redirectAuth: () => dispatch(push('/auth/callback'))
	})
)(LoggedOut);

export default ConnectedLoggedOut;


// WEBPACK FOOTER //
// ./src/chrome/LoggedOut.js